import React, { useState } from 'react';
import _ from 'lodash';
import Information from '../components/modals/common/Information';
import { ENV_VARS, ZENDESK_URL_NONE } from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';
import { getZendeskUrl } from '../utilities/commonUtil';

export const HelpMenu = () => {
  const [openHelpMenu, setOpenHelpMenu] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [showHelpCenterDialog, setShowHelpCenterDialog] = useState(false);

  const REACT_APP_ZENDESK_URL = ENV_VARS.REACT_APP_ZENDESK_URL;

  const useOutsideClick = callback => {
    const ref = React.useRef();

    React.useEffect(
      () => {
        const handleClick = event => {
          if (ref.current && !ref.current.contains(event.target)) {
            callback();
          }
        };

        document.addEventListener('click', handleClick);

        return () => {
          document.removeEventListener('click', handleClick);
        };
      },
      [ref]
    );

    return ref;
  };

  const handleClickOutside = () => {
    setOpenHelpMenu(false);
  };

  const ref = useOutsideClick(handleClickOutside);

  const toggleHelpMenu = () => {
    if (REACT_APP_ZENDESK_URL === ZENDESK_URL_NONE) {
      setShowHelpCenterDialog(true);
    } else {
      setOpenHelpMenu(!openHelpMenu);
    }
  };

  const handleChange = event => {
    setSearchValue(event.target.value);
  };

  const handleSubmit = event => {
    window.open(getZendeskUrl(REACT_APP_ZENDESK_URL, searchValue), '_blank');
    event.preventDefault();
  };

  return (
    <div className='help-menu' ref={ref}>
      <button className='btn-help' onClick={toggleHelpMenu}>
        <i className='i-manual-contact i-2x' aria-hidden='true' />
        <span className='btn-help__text'>ヘルプ</span>
      </button>
      <div className={openHelpMenu ? 'dropdown show' : 'dropdown'}>
        <div className='dropdown__item'>
          <p className='help-menu__title'>使い方を検索する</p>
          <form className='help-menu__form' onSubmit={handleSubmit}>
            <input
              className='help-menu__input-text'
              type='text'
              name='search'
              placeholder='キーワードを入力'
              value={searchValue}
              onChange={handleChange}
            />
            <input className='btn--stay' type='submit' value='検索' />
          </form>
          <a
            className='btn-text'
            id='faq-link'
            href={getZendeskUrl(REACT_APP_ZENDESK_URL)+"articles/40992742932761"}
            target='_blank'
            rel='noopener noreferrer'
          >
            よくあるご質問を確認する
          </a>
          <a
            className='btn-text'
            id='manual-link'
            href={getZendeskUrl(REACT_APP_ZENDESK_URL)+"categories/8252993944729"}
            target='_blank'
            rel='noopener noreferrer'
          >
            マニュアルを確認する
          </a>
          <a
            className='btn-text'
            id='help-center-link'
            href={getZendeskUrl(REACT_APP_ZENDESK_URL)}
            target='_blank'
            rel='noopener noreferrer'
          >
            ヘルプセンターのトップへ
          </a>
        </div>
      </div>
      <Information
        visible={showHelpCenterDialog}
        onClose={() => setShowHelpCenterDialog(false)}
        title={messageUtility.getMessage('E-000-005-01')}
        message={messageUtility.getMessage('E-000-005-02')}
        buttonText={messageUtility.getMessage('I-000-017')}
        multilineText={true}
        rootClassName={'dialog-md--help-center'}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/HelpMenu.jsx